import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import { ModelPublishParams, ModelTrainingParams, TrainingPicture } from "@/types/creatorcenter";

export interface MymodelState {
  trainingParams: ModelTrainingParams;
  trainingPictures: TrainingPicture[];
  currentTrainId: string;
  modelcovers: string[];
  currentModelCover: string,
  modelPublishParams: ModelPublishParams;
}

const initialState:MymodelState = {
  currentTrainId: "",
  trainingPictures:[],
  modelcovers: [],
  currentModelCover:"",
  trainingParams:{
    train_type: "FLUX",
    prompt: "living room",
    output_name: "aki", //模型名称
    generatetype: "室内设计", //类型
    pretrained_model_name_or_path: "./sd-models/flux1-dev-fp8.safetensors", //基础模型anything-v5-PrtRE
    repeat: 7, //单张次数？？
    max_train_epochs: 7, //循环轮次
    sample_seed: 1337,
    train_batch_size: 1, //批量大小
    mixed_precision: "fp16", // 训练混合精度
    resolution: "512,512", //样图分辨率
    seed: 1337, //随机种子数
    sample_sampler: "euler_a", //采样方式
    save_every_n_epochs: 2, //每N轮保存一个LoRA
    save_precision: "fp16", //LoRA保存精度
    learning_rate: 0.0001, //总学习率
    unet_lr: 0.0001, //UNET学习率
    text_encoder_lr: 0.00001, //文本编码器学习率
    lr_warmup_steps: 0, //学习率预热
    lr_scheduler: "cosine_with_restarts", //学习率调度器
    optimizer_type: "AdamW8bit", //优化器
    lr_scheduler_num_cycles: 1, //重启次数
    network_train_unet_only: true, //仅训练Unet
    network_train_text_encoder_only: false, //仅训练文本编码器
    min_snr_gamma: 0, //最小信噪比伽马值
    enable_block_weights: false, //启用分层学习率训练
    network_dim: 128, //网络大小
    network_alpha: 64, //网络Alpha
    shuffle_caption: false, //打乱标注
    weighted_captions: false, //使用带权重的token
    keep_tokens: 1, //保持n个token
    max_token_length: 225, //最大token长度
    clip_skip: 2, //clip跳过
    sample_every_n_epochs: 2,
    randomly_choice_prompt: false,
    positive_prompts: "masterpiece, best quality, living room",
    sample_width: 512,
    sample_height: 512
  },
  modelPublishParams:{
    id: "", //训练id
    user_id: "", //用户id
    status: "",  //发布状态，已发布
    model_name: "", //模型名称
    model_cover: "", //模型封面
    model_type: "",  //模型类型
    content_type: "", //内容类型
    model_desc: "",  //模型说明
    base_model: "", //基础模型
    trigger_word: "",  //模型触发词
    weight: "",  // 模型权重
    cfg_scale: "",  // 提示相关性
    can_see: false, // 是否公开： true：公开，false：仅自己可看
    pay_setting: false, // 付费设置：true：免费，false：会员下载
    cl: 0,  //创作许可范围： 0：允许在ALDGPT在线使用 1：允许下载生图 2：允许进行融合
    ca:0,  //商用权限：0：生成图片可出售或用于商业目的 1：生成图片可出售或用于商业目的
    model_preview: []  //模型发布预览图
  } as ModelPublishParams
};

export const mymodelSlice = createSlice({
  name: "mymodel",
  initialState,
  reducers: {
    updateTrainingParams: (state, action: PayloadAction<ModelTrainingParams>) => {
      state.trainingParams = action.payload;
      const wh = state.trainingParams.resolution.split(",");
      state.trainingParams.sample_width = Number(wh[0]);
      state.trainingParams.sample_height = Number(wh[1]);
      state.trainingParams.positive_prompts = "masterpiece, best quality," + state.trainingParams.prompt;
    },
    resetMyModel: () =>initialState,
    updateTrainingPictures: (state, action: PayloadAction<TrainingPicture[]>) => {
      state.trainingPictures = action.payload;
    },
    addTrainPicture:(state, action: PayloadAction<TrainingPicture>)=>{
      state.trainingPictures.push(action.payload)
    },
    updateCurrentTrainId: (state, action: PayloadAction<string>) => {
      state.currentTrainId = action.payload;
    },
    updateModelcovers: (state, action: PayloadAction<string[]>) => {
      state.modelcovers = action.payload;
    },
    updateCurrentModelCover: (state, action: PayloadAction<string>) => {
      state.currentModelCover = action.payload;
    },
    updateModelPublishParams: (state, action: PayloadAction<ModelPublishParams>) => {
      state.modelPublishParams = action.payload;
    },
    updateModelTrainType: (state, action: PayloadAction<string>) => {
      state.trainingParams.train_type = action.payload;
    },
  }
})
export const { 
  updateTrainingParams,
  resetMyModel, 
  updateTrainingPictures, 
  updateCurrentTrainId, 
  updateModelcovers, 
  updateCurrentModelCover, 
  updateModelPublishParams,
  addTrainPicture,
  updateModelTrainType,
} = mymodelSlice.actions;
export const selectTrainingParams = (state: RootState) => state.mymodel.trainingParams;
export const selectTrainingPictures = (state: RootState) => state.mymodel.trainingPictures;
export const selectCurrentTrainId = (state: RootState) => state.mymodel.currentTrainId;
export const selectModelcovers = (state: RootState) => state.mymodel.modelcovers;
export const selectCurrentModelCover = (state: RootState) => state.mymodel.currentModelCover;
export const selectModelPublishParams = (state: RootState) => state.mymodel.modelPublishParams;
export const selectMymodel = (state: RootState) => state.mymodel;
export default mymodelSlice.reducer;